import send from 'customer/lib/action'
import types from 'customer/types/Accounts.types'

export const getAccounts = () =>
  send({
    method: 'get',
    path: `/accounts.json`,
    baseType: types.GET_ACCOUNTS
  })
